import React, { createContext, useCallback, useContext, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false });
  const [resolver, setResolver] = useState(null);

  const confirm = useCallback(({ title = "Are you sure?", message = "", confirmText = "Confirm", cancelText = "Cancel", destructive = false } = {}) => {
    return new Promise((resolve) => {
      setState({ open: true, title, message, confirmText, cancelText, destructive });
      setResolver(() => resolve);
    });
  }, []);

  const handleClose = (result) => {
    setState((s) => ({ ...s, open: false }));
    if (resolver) resolver(result);
    setResolver(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Dialog open={state.open} onClose={() => handleClose(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{state.title}</DialogTitle>
        <DialogContent><DialogContentText>{state.message}</DialogContentText></DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>{state.cancelText}</Button>
          <Button onClick={() => handleClose(true)} variant="contained" color={state.destructive ? "error" : "primary"} autoFocus>
            {state.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used inside <ConfirmProvider>");
  return ctx;
}
